(() => {
  if (window.TDFWProductReference) return;
  window.TDFWProductReference = true;
  const observed = new WeakSet();
  let cartQueue = Promise.resolve();
  function syncProduct(root) {
    const sectionId = root.dataset.sectionId;
    const bar = document.querySelector(`[data-reference-sticky][data-reference-section="${sectionId}"]`);
    const button = root.querySelector('[data-add-to-cart]');
    const price = root.querySelector('.product-detail__price [data-product-price]');
    if (bar) {
      bar.hidden = !button;
      if (button) {
        const stickyButton = bar.querySelector('[data-reference-sticky-add]');
        stickyButton.disabled = button.disabled;
        const text = button.textContent.trim();
        if (stickyButton.textContent !== text) stickyButton.textContent = text;
        const stickyPrice = bar.querySelector('[data-reference-sticky-price]');
        if (price && stickyPrice.textContent !== price.textContent.trim()) stickyPrice.textContent = price.textContent.trim();
      }
    }
  }
  function updateNavOffset() {
    const nav = document.querySelector('.mobile-app-navigation');
    const height = nav && getComputedStyle(nav).display !== 'none' ? nav.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--ppr-bottom-offset', `${Math.ceil(height)}px`);
  }
  function activateTab(container, button, focus = false) {
    container.querySelectorAll('[data-reference-tab]').forEach(tab => {
      const active = tab === button;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });
    container.querySelectorAll('[data-reference-panel]').forEach(panel => {
      panel.hidden = panel.id !== button.getAttribute('aria-controls');
    });
    if (focus) button.focus();
  }
  async function refreshCartPage() {
    const cartRoot = document.querySelector('[data-section-type="cart"][data-section-id]');
    if (!cartRoot) return;
    // An empty cart has no editable order fields or item list yet.
    if (!cartRoot.querySelector('.cart-items')) { window.location.reload(); return; }
    const marketRoot = window.Shopify?.routes?.root || '/';
    const url = new URL(window.theme?.routes?.cart_url || marketRoot + 'cart', location.origin);
    url.searchParams.set('section_id', cartRoot.dataset.sectionId);
    const response = await fetch(url.href, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Cart refresh failed');
    const page = new DOMParser().parseFromString(await response.text(), 'text/html');
    const fresh = [...page.querySelectorAll('[data-section-type="cart"]')].find(el => el.dataset.sectionId === cartRoot.dataset.sectionId);
    if (!fresh?.querySelector('.cart-items') || !fresh.querySelector('.subtotal-row')) throw new Error('Cart markup missing');
    // Preserve notes, height, delivery date, marketing source and checkout form.
    for (const selector of ['.cart-items', '.subtotal-row', '.mad-cart-list-title']) {
      const target = cartRoot.querySelector(selector), replacement = fresh.querySelector(selector);
      if (target && replacement) target.innerHTML = replacement.innerHTML;
    }
  }
  function init() {
    document.querySelectorAll('[data-product-reference]').forEach(root => {
      root.classList.add('ppr-js');
      syncProduct(root);
      const detail = root.querySelector('.product-detail__detail');
      if (detail && !observed.has(detail)) {
        observed.add(detail);
        new MutationObserver(() => syncProduct(root)).observe(detail, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
      }
    });
    document.querySelectorAll('[data-reference-accessories]').forEach(container => {
      const first = container.querySelector('[data-reference-tab]');
      if (first) activateTab(container, first);
    });
    if (window.jQuery && !window.TDFWProductReferenceVariants) {
      window.TDFWProductReferenceVariants = true;
      window.jQuery(document).on('variantChange.ppr', '[data-product-reference]', function(event) {
        const variant = event.variant;
        const savings = this.querySelector('[data-reference-saving]');
        if (savings) {
          savings.hidden = !variant || !(variant.compare_at_price > variant.price);
          if (!savings.hidden) {
            const currency = window.Shopify?.currency?.active || 'EUR';
            savings.textContent = 'Bespaar ' + new Intl.NumberFormat(document.documentElement.lang || 'nl', { style: 'currency', currency }).format((variant.compare_at_price - variant.price) / 100);
          }
        }
        const stock = this.querySelector('[data-reference-stock]');
        if (stock) stock.hidden = !variant?.available;
        const note = this.querySelector('[data-reference-stock-note]');
        if (note) {
          const option = this.querySelector(`select[data-product-select] option[value="${variant?.id}"]`);
          const quantity = Number(option?.dataset.inventory || 0);
          note.hidden = !variant?.available || quantity < 1 || quantity > 5 || variant.inventory_policy === 'continue';
          if (!note.hidden) note.textContent = `Nog maar ${quantity} beschikbaar`;
        }
        requestAnimationFrame(() => syncProduct(this));
      });
    }
    updateNavOffset();
  }
  document.addEventListener('click', event => {
    const sticky = event.target.closest('[data-reference-sticky-add]');
    if (sticky) {
      const bar = sticky.closest('[data-reference-sticky]');
      const root = Array.from(document.querySelectorAll('[data-product-reference]')).find(item => item.dataset.sectionId === bar.dataset.referenceSection);
      const button = root?.querySelector('[data-add-to-cart]');
      if (button && !button.disabled && button.form) button.form.requestSubmit(button);
      return;
    }
    const tab = event.target.closest('[data-reference-tab]');
    if (tab) activateTab(tab.closest('[data-reference-accessories]'), tab);
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('[data-reference-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const container = tab.closest('[data-reference-accessories]');
    const tabs = Array.from(container.querySelectorAll('[data-reference-tab]'));
    let index = tabs.indexOf(tab);
    if (event.key === 'Home') index = 0;
    else if (event.key === 'End') index = tabs.length - 1;
    else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    event.preventDefault();
    activateTab(container, tabs[index], true);
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('[data-reference-accessory-form]')) return;
    event.preventDefault();
    if (form.dataset.busy) return;
    form.dataset.busy = 'true';
    const data = new FormData(form);
    const button = form.querySelector('[type="submit"]');
    const status = form.querySelector('[role="status"]');
    const label = button.textContent;
    button.disabled = true;
    button.textContent = 'Toevoegen…';
    status.textContent = '';
    cartQueue = cartQueue.then(async () => {
      let added = false;
      const root = window.Shopify?.routes?.root || '/';
      try {
        const response = await fetch(root + 'cart/add.js', { method: 'POST', body: data, credentials: 'same-origin', headers: { Accept: 'application/json' } });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Toevoegen mislukt.');
        added = true;
        const cartResponse = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
        if (!cartResponse.ok) throw new Error('Toegevoegd. Winkelwagen bijwerken mislukt.');
        const cart = await cartResponse.json();
        document.querySelectorAll('[data-mobile-cart-count], .header-cart .header-cart__count:not([data-wishlist-count]), .cart-summary__total-quantity-row > span:last-child').forEach(count => { count.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        await refreshCartPage();
        status.textContent = 'Toegevoegd aan winkelwagen';
      } catch(error) {
        status.textContent = added ? 'Toegevoegd. Controleer uw winkelwagen.' : error.message;
      } finally {
        delete form.dataset.busy;
        button.disabled = false;
        button.textContent = label;
      }
    });
  });
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', updateNavOffset);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
(() => {
  function moveProductAccordions() {
    document.querySelectorAll('[data-product-reference]').forEach(root => {
      const grid = root.querySelector('.product-layout-grid');
      if (!grid) return;

      root.querySelectorAll('.ppr-accordion').forEach(accordion => {
        if (accordion.parentElement !== grid) {
          grid.appendChild(accordion);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveProductAccordions);
  } else {
    moveProductAccordions();
  }

  document.addEventListener('shopify:section:load', moveProductAccordions);
})();